import React from "react";
import FooterCopyRight from "../components/FooterCopyRight";
import Header from "../components/Header";
import TokenDetailsSection3 from "../components/TokenDetailsSection3";
import Footer from "../components/Footer";

const TokenDetails3 = () => {
	return (
		<>
			<Header />
			<TokenDetailsSection3 />
			<Footer/>
		</>
	);
};

export default TokenDetails3;
